import { Component, ElementRef, Input, OnChanges, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-user-avatar',
  template: `
    <span
      class="account-avatar"
      #item
      [ngStyle]="{ 'background-color': bgs[type], color: colors[type] }"
      [ngClass]="'size-' + size"
      ><span class="text">{{ initials }}</span></span
    >
  `,
  styles: [
    `
      .vip-member {
        background: url('/assets/images/vip/vip.svg') center center no-repeat;
        background-size: 60px 60px;
        width: 60px;
        height: 60px;
      }
    `,
    `
      .vip-member .text {
        display: none;
      }
    `,
  ],
})
export class UserAvatarComponent implements OnInit, OnChanges {
  @Input('user') user: any = null;
  @Input('size') size: string = 'small';
  @ViewChild('item') item: ElementRef = null;

  initials: string = 'EDG';
  type: number = 0;
  colors: string[] = [
    'rgba(157, 121, 188, .5)',
    'hsla(7, 80%, 64%, .5)',
    'rgba(68, 157, 209, .5)',
    'rgba(255, 166, 48, .5)',
    'hsla(57, 75%, 84%, .5)',
  ];
  bgs: string[] = [
    'rgba(157, 121, 188, .1)',
    'hsla(7, 80%, 64%, .1)',
    'rgba(68, 157, 209, .1)',
    'rgba(255, 166, 48, .1)',
    'hsla(57, 75%, 84%, .1)',
  ];

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    this.becomeVip();
  }
  ngOnChanges() {
    if (this.user) {
      if (this.user.username) {
        this.initials = this.getUps(this.user.username) || this.getFirstLetters(this.user.username);
        this.type = this.getColorSchemeId(this.user.username);
        this.becomeVip();
      }
    }
  }

  becomeVip() {
    if (this.user && this.renderer && this.item) {
      if (this.user.vip) {
        this.renderer.addClass(this.item.nativeElement, 'vip-member');
      } else {
        this.renderer.removeChild(this.item.nativeElement, 'vip-member');
      }
    }
  }

  getUpsPos(string: string): Array<number> {
    const positions = [];
    for (let i = 0; i < string.length; i++) {
      if (string[i].match(/[A-Z]/) != null) {
        positions.push(i);
      }
    }
    return positions;
  }

  getUps(string: string, limit: number = 2): string {
    let result = '';
    const positions = this.getUpsPos(string);
    for (let i = 0; i < (positions.length >= limit ? limit : positions.length); i++) {
      result += string.charAt(positions[i]);
    }
    return result;
  }

  getFirstLetters(string: string, limit: number = 2): string {
    let result = '';
    for (let i = 0; i < limit; i++) {
      result += string.charAt(i);
    }
    return result;
  }

  getHashCode(s: string): number {
    let h = 0;
    const l = s.length;
    let i = 0;
    if (l > 0) {
      while (i < l) {
        h = ((h << 5) - h + s.charCodeAt(i++)) | 0;
      }
    }
    return h;
  }

  getColorSchemeId(name: string): number {
    const code = Number(String(Math.abs(this.getHashCode(name))).charAt(0));
    if (code < 2) {
      return 0;
    } else if (code >= 2 && code < 4) {
      return 1;
    } else if (code >= 4 && code < 6) {
      return 2;
    } else if (code >= 6 && code < 8) {
      return 3;
    }
    return 4;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/user-avatar.component.ts